import { type FC, type ReactElement } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

export const seeDetails = (
    <FormattedMessage id="global.seeDetailsCta" defaultMessage="See details" />
);

type FollowSearchProps = {
    searchName: string;
    searchNameClassname?: string;
};

export const FollowSearch: FC<FollowSearchProps> = ({ searchName, searchNameClassname }) => (
    <FormattedMessage
        id="global.followSearch"
        defaultMessage="Follow {searchName} to receive alerts when new items arrive"
        values={{
            searchName: <span className={searchNameClassname || ''}>{searchName}</span>,
        }}
    />
);

export const moreDetails = (
    <FormattedMessage id="global.moreDetails" defaultMessage="More Details" />
);
export const details = <FormattedMessage id="global.details" defaultMessage="Details" />;
export const seeLess = <FormattedMessage id="abf.global.seeLess.copy" defaultMessage="See Less" />;
export const viewAllVisuallySimilar = (
    <FormattedMessage id="global.viewAllVisuallySimilar" defaultMessage="View All" />
);

export const viewAllInCollection = (
    <FormattedMessage id="global.viewAllInCollection" defaultMessage="View All" />
);

export const untitledCollectionName = (
    <FormattedMessage defaultMessage="Untitled Collection" id="global.untitledCollectionName" />
);

export const viewSimilarItems = (
    <FormattedMessage id="global.viewSimilarItems" defaultMessage="View Similar Items" />
);

export const visuallySimilar = (
    <FormattedMessage id="global.visuallySimilar" defaultMessage="Visually Similar" />
);

export const moreFromThisSeller = (
    <FormattedMessage id="global.moreFromThisSeller" defaultMessage="More From This Seller" />
);

export const feesLimitsApply = (
    <FormattedMessage id="global.feesLimitsApply" defaultMessage="Fees and limitations apply." />
);

export const learnMore = <FormattedMessage id="global.learnMore" defaultMessage="Learn More" />;

export const buyerProtection = (
    <FormattedMessage
        id="global.buyerProtectionTitleGuaranteed"
        defaultMessage="All purchases are covered by our Buyer Protection Guarantee."
    />
);

export const email = <FormattedMessage id="global.email" defaultMessage="Email" />;

type ItemsSimilarToHeaderProps = {
    title: ReactElement;
};
export const ItemsSimilarToHeader: FC<ItemsSimilarToHeaderProps> = ({ title }) => (
    <FormattedMessage
        values={{ title }}
        id="global.itemsSimilarToHeader"
        defaultMessage="Items Similar to {title}"
    />
);

export const recentlyViewed = (
    <FormattedMessage id="global.recentlyViewed" defaultMessage="Recently Viewed" />
);

export const viewAllFromSeller = (
    <FormattedMessage
        id="pdp.PdpMobileDealerItems.view_all_from_seller"
        defaultMessage="View All"
    />
);

export const viewAll = (
    <FormattedMessage id="pdp.PdpMobileDealerItems.view_all" defaultMessage="View All" />
);
export const startConversationMessage = (
    <FormattedMessage id="global.starConversation" defaultMessage="Ask the Seller" />
);

export const messageSeller = (
    <FormattedMessage id="global.messageSeller" defaultMessage="Message the Seller" />
);

export const itemStatus = <FormattedMessage id="global.itemStatus" defaultMessage="Item Status:" />;

export const lookingSomethingSimilar = (
    <FormattedMessage
        id="global.lookingSomethingSimilar"
        defaultMessage="Looking for something similar?"
    />
);

export const sellerInformation = (
    <FormattedMessage id="global.sellerInformation" defaultMessage="Seller Information" />
);

export const buyerIncentives = (
    <FormattedMessage id="global.buyerIncentives" defaultMessage="The 1stDibs Promise" />
);

export const itemDetails = (
    <FormattedMessage id="global.itemDetails" defaultMessage="Item Details" />
);

export const moreItems = <FormattedMessage id="global.moreItems" defaultMessage="More Items" />;
export const shippingAndReturns = (
    <FormattedMessage id="global.shippingAndReturns" defaultMessage="Shipping & Returns" />
);
export const customization = (
    <FormattedMessage id="global.customization" defaultMessage="Customization" />
);
